<template>
  <div v-if="organization">
    <b-row>
      <b-col>
        <b-form-group label-for="isGalatea">
          <b-form-checkbox v-model="organization.isGalatea" size="lg" switch><span>¿Funcionalidades
              GALATEA?</span></b-form-checkbox> <b-input v-if="organization.isGalatea"
            v-model="organization.galateaCodeTelesoporte" size="xs" type="text"
            placeholder="Código telesoporte (Si no tiene valor, el valor por defecto sera TSEPS)"></b-input>
          <span v-if="organization.isGalatea">Plantilla bienvenida</span>
          <b-form-select v-if="organization.isGalatea" v-model="organization.surveyWelcomeTemplate" :options="templatesSelect" />
        </b-form-group>
        <b-form-group label-for="planMulticonference">
          <b-form-checkbox v-model="organization.planMulticonference" size="lg" switch><span>¿Permitir
              multiconferencia?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planPatientWelcome">
          <b-form-checkbox v-model="organization.planPatientWelcome" size="lg" switch><span>¿Permitir envio email
              bienvenida
              paciente?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planRecorded">
          <b-form-checkbox v-model="organization.planRecorded" size="lg" switch><span>¿Permitir
              grabación?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planSendReminderWallet">
          <b-form-checkbox v-model="organization.planSendReminderWallet" size="lg" switch><span>¿Permitir recordatorio
              recarga
              cartera (al crear cita)?</span></b-form-checkbox>
          <b-input v-if="organization.planSendReminderWallet" v-model="organization.planSendReminderWalletLimit"
            size="xs" type="number" placeholder="Recordatorio"></b-input>
          <span v-if="organization.planSendReminderWallet">Si el valor es 0, el limite sera el valor de la última
            cita.</span>
        </b-form-group>
        <b-form-group label-for="planSurvey">
          <b-form-checkbox v-model="organization.planSurvey" size="lg" switch><span>¿Permitir
              encuestas?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planInteractive">
          <b-form-checkbox v-model="organization.planInteractive" size="lg" switch><span>¿Permitir
              interactive?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planDashboardPicture">
          <b-form-checkbox v-model="organization.planDashboardPicture" size="lg" switch><span>¿Permitir imagen
              dashboard?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planReminders">
          <b-form-checkbox v-model="organization.planReminders" size="lg" switch><span>¿Permitir
              recordatorios?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planAlerts">
          <b-form-checkbox v-model="organization.planAlerts" size="lg" switch><span>¿Permitir
              mensajeria?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planPayments">
          <b-form-checkbox v-model="organization.planPayments" size="lg" switch><span>¿Permitir
              pagos?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planCustomize">
          <b-form-checkbox v-model="organization.planCustomize" size="lg" switch><span>¿Permitir
              personalización?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planInvoice">
          <b-form-checkbox v-model="organization.planInvoice" size="lg" switch><span>¿Permitir
              facturación?</span></b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label-for="planRatings">
          <b-form-checkbox v-model="organization.planRatings" size="lg" switch><span>¿Permitir
              valoraciones?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planHc">
          <b-form-checkbox v-model="organization.planHc" size="lg" switch><span>¿Permitir hc?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planPetitioners">
          <b-form-checkbox v-model="organization.planPetitioners" size="lg" switch><span>¿Permitir
              peticionarios?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planShareFiles">
          <b-form-checkbox v-model="organization.planShareFiles" size="lg" switch><span>¿Permitir compartir
              archivos?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planPublicPerfil">
          <b-form-checkbox v-model="organization.planPublicPerfil" size="lg" switch><span>¿Permitir perfil
              público?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planPaymentsPaypal">
          <b-form-checkbox v-model="organization.planPaymentsPaypal" size="lg" switch><span>¿Permitir parelas
              PayPal?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planPaymentsStripe">
          <b-form-checkbox v-model="organization.planPaymentsStripe" size="lg" switch><span>¿Permitir parelas
              Stripe?</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="planPaymentsWallet">
          <b-form-checkbox v-model="organization.planPaymentsWallet" size="lg" switch><span>¿Permitir
              monedero?</span></b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { xray } from "../../config/pluginInit";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import professionalService from "../../services/professional";
import organization from '../../services/organization';

export default {
  name: "OrganizationPreferenceAdmin",
  props: {
    organization: undefined,
  },
  mounted() {
    xray.index();
    this.getAllTemplates();
  },
  methods: {
    async getAllTemplates() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getAllTemplatesSurveyPerformance(localStorage.getItem("userId")),
        (response) => {
          if (response) {
            self.templates = response.data;

            let combo = [];
            response.data.forEach(function (item) {
              let data = {
                value: item.uuid,
                text: item.name,
              };
              combo.push(data);
            });
            self.templatesSelect = combo;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllTemplatesSurveyPerformance",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional
            })
          });
        },
        " "
      );
    },
  },
  computed: {},
  data() {
    return { templatesSelect: []};
  },
  components: { Multiselect },
};
</script>